// extracted by mini-css-extract-plugin
module.exports = {"Table":"TreeList_Table__3xElf","RolesTable":"TreeList_RolesTable__xjpuz","ContextualTreeList":"TreeList_ContextualTreeList__2l-48"};